// Auto-generated from Figma tokens via Style-Dictionary - Do not edit manually
// Generated on: 2025-06-04T01:13:37.583Z

export const darkTheme = {
  color: {
    surface: {
      0: '#333332',
      1: '#1f1e1e',
      2: '#141414',
      3: '#0f0f0e',
      4: '#0d0c0c',
      5: '#000000',
      '0--halftone': '#000000',
      '1--halftone': '#0d0c0c',
      '2-halftone': '#262524',
      '3-halftone': '#302f2e',
      '4-halftone': '#555452',
      cool: {
        1: '#002c31',
        2: '#172426',
      },
    },
    grid: {
      base: '#141414',
      stripe: '#0d0d0d',
      hover: '#203a3f',
      select: '#0e1b1e',
      'select-inherited': '#05090a',
      'select-inherited-stripe': '#0b1517',
    },
    focus: {
      1: '#c1eff9',
      2: '#93bbc3',
      3: '#4d696f',
      4: '#2b3a3d',
      5: '#1f3033',
      6: '#0a1315',
    },
    brand: {
      'brand-bright-blue': '#a7eef9',
      'brand-bright-green': '#7affa2',
      'brad-dark-teal': '#002c31',
    },
    dataVis: {
      qualitative: {
        'yellow-1': '#8d6f05',
        'yellow-2': '#e8c23a',
        'yellow-3': '#ffe484',
        'orange-1': '#ac6a05',
        'orange-2': '#e89f30',
        'orange-3': '#ffc46a',
        'lime-1': '#818c09',
        'lime-2': '#b7c142',
        'lime-3': '#e5ee7e',
        'moss-1': '#498524',
        'moss-2': '#80c456',
        'moss-3': '#cdf0b7',
        'teal-1': '#0c7d4e',
        'teal-2': '#5bcb9c',
        'teal-3': '#b1f6d9',
        'blue-1': '#0d5c8e',
        'blue-2': '#5ba0cb',
        'blue-3': '#bddef3',
        'violet-1': '#46408a',
        'violet-2': '#645bcb',
        'violet-3': '#9e97ed',
        'mauve-1': '#762f8f',
        'mauve-2': '#ae5bcb',
        'mauve-3': '#d397e8',
        'magenta-1': '#8c2f50',
        'magenta-2': '#cb5b83',
        'magenta-3': '#e9a1bb',
      },
      alert: {
        'limit-1': '#894242',
        'limit-2': '#ff7171',
        'anomaly-1': '#2d3a3c',
        'anomaly-2': '#4e8188',
        'anomaly-3': '#b0ffb0',
        'limit-1-halftone': '#894242',
        'limit-2-halftone': '#ff7171',
      },
      core: {
        'critical-2': '#ff7171',
        'critical-1': '#ffbcbc',
        'critical-1-halftone': '#ffbcbc',
        'critical-2-halftone': '#ff7171',
        'data-emphasis': '#ffffff',
        'data-primary': '#d9d9d9',
        'data-secondary': '#a6a6a6',
        'data-tertiary': '#666666',
        'surface-1': '#080707',
        'surface-0': '#000000',
        'surface-0-halftone-75%': '#000000',
        'surface-1-halftone-75%': '#080707',
        'data-tertiary-halftone': '#666666',
        'surface-1-halftone-0%': '#080707',
        'surface-0-halftone-0%': '#000000',
      },
    },
    text: {
      core: {
        '-primary': '#d9d9d9',
        '-emphasis': '#ffffff',
        '-tertiary': '#666666',
        '-secondary': '#a6a6a6',
        '-link': '#c1eff9',
        'on-dark-primary': '#ffffff',
        'on-dark-secondary': '#d9d9d9',
        'on-light-primary': '#1e1e1e',
        'on-light-secondary': '#737373',
      },
    },
    neutral: {
      grey: {
        opaque: {
          'k-100': '#ffffff',
          'k-97': '#f7f7f7',
          'k-95': '#f2f2f2',
          'k-90': '#e6e6e6',
          'k-85': '#d9d9d9',
          'k-80': '#cccccc',
          'k-65': '#a6a6a6',
          'k-55': '#8c8c8c',
          'k-40': '#666666',
          'k-30': '#333333',
          'k-20': '#333333',
          'k-15': '#262626',
          'k-12': '#1f1f1f',
          'k-10': '#1a1a1a',
          'k-8': '#141414',
          'k-5': '#0d0d0d',
          'k-3': '#080808',
          'k-0': '#000000',
        },
        transparent: {
          'k-50%': '#000000',
          'k-20%': '#000000',
          'k-15%': '#000000',
          'k-10%': '#000000',
          'k-75%': '#000000',
        },
      },
    },
    control: {
      button: {
        primary: '#002c31',
        secondary: '#222320',
        'primary-hover': '#3c6a73',
        'secondary-hover': '#203b40',
      },
      input: {
        neutral: '#141414',
      },
    },
    lighting: {
      'deboss-shadow': '#000000',
      'ai-teal': '#2a9073',
      'ai-purple': '#4f2d87',
      'ai-teal-halftone': '#2a9073',
      'ai-purple-halftone': '#4f2d87',
      'action-teal': '#aaf0ff',
      'highlight-1': '#ffffff',
      'shadow-2': '#000000',
      'shadow-3': '#000000',
      'shadow-1': '#000000',
    },
  },
  size: {
    spacing: {
      small: '4px',
      medium: '8px',
      large: '16px',
      xs: '2px',
      xl: '24px',
      xxl: '32px',
      xxxl: '40px',
      xxxxl: '48px',
    },
    radius: {
      'radius-xs': '2px',
      'radius-small': '4px',
      'radius-medium': '8px',
      'radius-large': '12px',
    },
  },
};
